import React from "react";
import { Modal, ModalHeader } from "../../globalComponents/ui/Modal";
import { PrimaryButton } from "../../globalComponents/ui/Button";

/**
 * Explains one of the AI's choices in its own words.
 *
 * @param {{show: boolean, title: string, body: string, onClose: function}} props - Content and visibility.
 * @returns {JSX.Element} The modal.
 *
 * @remarks
 * The body is generated alongside the analysis rather than written here, so the
 * explanation always describes the run being looked at rather than the feature
 * in general.
 */
const WhyModal = ({ show, title, body, onClose }) => (
  <Modal show={show} onClose={onClose} maxWidth={560}>
    <ModalHeader icon="fas fa-lightbulb" title={title} onClose={onClose} />
    <div className="aica-modal-body">
      <p>{body || "No explanation was recorded for this analysis."}</p>
    </div>
    <div className="aica-modal-footer">
      <PrimaryButton type="button" onClick={onClose}>
        Close
      </PrimaryButton>
    </div>
  </Modal>
);

export default WhyModal;
